const host = "/api";

export default host;
export const app_api = `https://sdichome-api.stac.fun`;
export const community_host = "/community-service";
export const maintenance_url =
  "https://hdjz-test.oss-cn-beijing.aliyuncs.com/file/public/json-feasibility-566930348814063216-OP0002.json";
